import * as React from 'react';
import { connect } from 'react-redux';
import { Card } from 'react-bootstrap';
import { Image } from 'react-bootstrap';
import { hideMobileProfile } from '../../actions/profileActions';
import './PremiumBreakdown.css';
import { DASHBOARD, PERSONAL_INSURANCE, REQUEST_DOCUMENTS } from '../../routes/routes';
import KPBreadCrumb from '../KPBreadCrumb/KPBreadCrumb';
import { navigateTo } from '../../actions/navigationActions';

class PremuimBreakdown extends React.PureComponent<any, any> {

    constructor(props: any) {
        super(props);

        this.redirectTo = this.redirectTo.bind(this);
    }

    componentDidMount() {
        this.props.dispatchHideProfile();
    }

    redirectTo(destination) {
        this.props.dispatchRedirectTo(destination);
    };

    public render() {
        let BreadcrumbDetails = [{ destination: DASHBOARD, description: "Home" }, { destination: PERSONAL_INSURANCE, description: "Personal insurance" }]
        let cars = "0.00";
        let chilli = "0.00"
        let motorbikes = "0.00"
        let trailers = "0.00"
        let caravans = "0.00"
        let homeContent = "0.00"
        let buildings = "0.00"
        let portablePossessions = "0.00"
        let sasria = "0.00"
        let discount = "0.00"
        let emergency = "0.00"
        let fees = "0.00"
        let warranty = "0.00"
        let blingLikeNew = "0.00"
        let blingBrandNew = "0.00"
        let blingScreenFix = "0.00"
        let totalPolicyPremium = "0.00";
        let nextDebitDate = "";
        let policyNumber = "";
        let donate = "0.00";
        let stampDuty = "0.00";
        let namfisa = "0.00";
        if (this.props.profile.selectedPersonalPolicy !== undefined) {
            cars = this.props.profile.selectedPersonalPolicy.premiumBreakdown.cars;
            chilli = this.props.profile.selectedPersonalPolicy.premiumBreakdown.chilli;
            motorbikes = this.props.profile.selectedPersonalPolicy.premiumBreakdown.motorbikes;
            trailers = this.props.profile.selectedPersonalPolicy.premiumBreakdown.trailers;
            caravans = this.props.profile.selectedPersonalPolicy.premiumBreakdown.caravans;
            homeContent = this.props.profile.selectedPersonalPolicy.premiumBreakdown.homeContents;
            buildings = this.props.profile.selectedPersonalPolicy.premiumBreakdown.buildings;
            portablePossessions = this.props.profile.selectedPersonalPolicy.premiumBreakdown.portablePossessions;
            sasria = this.props.profile.selectedPersonalPolicy.premiumBreakdown.sasria;
            discount = this.props.profile.selectedPersonalPolicy.premiumBreakdown.multipleCarDiscount;
            emergency = this.props.profile.selectedPersonalPolicy.premiumBreakdown.emergencyAssist;
            fees = this.props.profile.selectedPersonalPolicy.premiumBreakdown.brokerAdviceFee;
            donate = this.props.profile.selectedPersonalPolicy.premiumBreakdown.donateDecrease;
            warranty = this.props.profile.selectedPersonalPolicy.premiumBreakdown.warranty;
            blingLikeNew = this.props.profile.selectedPersonalPolicy.premiumBreakdown.blingLikeNew;
            blingBrandNew = this.props.profile.selectedPersonalPolicy.premiumBreakdown.blingBrandNew;
            blingScreenFix = this.props.profile.selectedPersonalPolicy.premiumBreakdown.blingScreenFix;
            stampDuty = this.props.profile.selectedPersonalPolicy.premiumBreakdown.stampDuty;
            namfisa = this.props.profile.selectedPersonalPolicy.premiumBreakdown.namfisa;
            totalPolicyPremium = this.props.profile.selectedPersonalPolicy.totalPolicyPremium;
            nextDebitDate = this.props.profile.selectedPersonalPolicy.nextDebitOrderDate;
            policyNumber = this.props.profile.selectedPersonalPolicy.policyNumber;
        }
        return (
            <div id="PremiumBreakdown" className="pt-lg-0">
                <KPBreadCrumb navList={BreadcrumbDetails} activePage="Premium breakdown" />
                <div id="cardDesktop">
                    <div className="col-12 col-lg-12 mb-3">
                        <div className="row">
                            <div className="Personal-insurance-breakdown w-100">
                                <div className="row">
                                    <div className="col-lg-9 col-12">
                                        <h3 className="Premium-breakdown-title pt-2">Premium breakdown</h3>
                                        <p className="pColor mt-5 mt-lg-1 mb-1">Total monthly premium</p>
                                        <h3 className="text-white PremiumAmount mb-0">{this.props.profile.currencySymbol}{totalPolicyPremium} pm</h3>
                                    </div>
                                    <div className="col-lg-3 d-none d-lg-block d-sm-none d-xl-block">
                                        <button type="button" className="btn btn-solid-green btn-email-policy" onClick={() => this.redirectTo(REQUEST_DOCUMENTS)}>Email my schedule</button>
                                    </div>
                                </div>
                                <hr className="Stroke" />
                                <div className="row">
                                    <div className="col-7 col-lg-6">
                                        <p className="pColor mb-0">Next debit order</p>
                                        <p className="pColor pDetails">{nextDebitDate}</p>
                                    </div>
                                    <div className="col-5 col-lg-6">
                                        <p className="pColor text-right mb-0">Policy no.</p>
                                        <p className="pColor text-right pDetails">{policyNumber}</p>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-12 mb-3 d-block d-lg-none d-sm-block d-xl-none">
                                        <button type="button" className="btn btn-solid-green w-100" onClick={() => this.redirectTo(REQUEST_DOCUMENTS)}>Email my schedule</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <Card id="premiumCard" className="card mx-auto mt-3 mb-3">
                                <Card.Body className="mt-3 mb-3">
                                    {cars !== "0.00" &&
                                        <>
                                            <div className="row py-1">
                                                <div id="DivPremiumBreakdownCar" className="col">
                                                    <div className="car"></div>
                                                    <div>
                                                        <p className="">Car/s</p>
                                                    </div>
                                                </div>
                                                <div className="col">
                                                    <p className="greenPremium">{this.props.profile.currencySymbol}{cars}</p>
                                                </div>
                                            </div>
                                            <hr />
                                        </>
                                    }

                                    {chilli !== "0.00" &&
                                        <>
                                            <div className="row py-2">
                                                <div id="DivPremiumBreakdownCar" className="col">
                                                    <Image src='/Images/PremiumBreakdown/icon-chilli.svg' alt='' />
                                                    <div>
                                                        <p className="">Chilli car/s</p>
                                                    </div>
                                                </div>
                                                <div className="col">
                                                    <p className="greenPremium">{this.props.profile.currencySymbol}{chilli}</p>
                                                </div>
                                            </div>
                                            <hr />
                                        </>
                                    }

                                    {motorbikes !== "0.00" &&
                                        <>
                                            <div className="row py-2">
                                                <div id="DivPremiumBreakdownCar" className="col">
                                                    <Image src='/Images/PremiumBreakdown/icon-motorbike-insurance.svg' alt='' />
                                                    <div>
                                                        <p>Motorbike/s</p>
                                                    </div>
                                                </div>
                                                <div className="col">
                                                    <p className="greenPremium">{this.props.profile.currencySymbol}{motorbikes}</p>
                                                </div>
                                            </div>
                                            <hr />
                                        </>
                                    }

                                    {trailers !== "0.00" &&
                                        <>
                                            <div className="row py-2">
                                                <div id="DivPremiumBreakdownCar" className="col">
                                                    <Image src='/Images/PremiumBreakdown/icon-trailer-insurance.svg' alt='' />
                                                    <div>
                                                        <p>Trailer/s</p>
                                                    </div>
                                                </div>
                                                <div className="col">
                                                    <p className="greenPremium">{this.props.profile.currencySymbol}{trailers}</p>
                                                </div>
                                            </div>
                                            <hr />
                                        </>
                                    }

                                    {caravans !== "0.00" &&
                                        <>
                                            <div className="row py-2">
                                                <div id="DivPremiumBreakdownCar" className="col">
                                                    <Image src='/Images/PremiumBreakdown/icon-caravan-insurance.svg' alt='' />
                                                    <div>
                                                        <p>Caravan/s</p>
                                                    </div>
                                                </div>
                                                <div className="col">
                                                    <p className="greenPremium">{this.props.profile.currencySymbol}{caravans}</p>
                                                </div>
                                            </div>
                                            <hr />
                                        </>
                                    }

                                    {homeContent !== "0.00" &&
                                        <>
                                            <div className="row py-2">
                                                <div id="DivPremiumBreakdownCar" className="col">
                                                    <Image src='/Images/PremiumBreakdown/icon-home-contents-insurance.svg' alt='' />
                                                    <div>
                                                        <p>Home content/s</p>
                                                    </div>
                                                </div>
                                                <div className="col">
                                                    <p className="greenPremium">{this.props.profile.currencySymbol}{homeContent}</p>
                                                </div>
                                            </div>
                                            <hr />
                                        </>
                                    }

                                    {buildings !== "0.00" &&
                                        <>
                                            <div className="row py-2">
                                                <div id="DivPremiumBreakdownCar" className="col">
                                                    <Image src='/Images/PremiumBreakdown/icon-building-insurance.svg' alt='' />
                                                    <div>
                                                        <p>Buildings</p>
                                                    </div>
                                                </div>
                                                <div className="col">
                                                    <p className="greenPremium">{this.props.profile.currencySymbol}{buildings}</p>
                                                </div>
                                            </div>
                                            <hr />
                                        </>
                                    }

                                    {portablePossessions !== "0.00" &&
                                        <>
                                            <div className="row py-2">
                                                <div id="DivPremiumBreakdownCar" className="col">
                                                    <Image src='/Images/PremiumBreakdown/icon-portable-possessions.svg' alt='' />
                                                    <div>
                                                        <p>Portable possessions</p>
                                                    </div>
                                                </div>
                                                <div className="col">
                                                    <p className="greenPremium">{this.props.profile.currencySymbol}{portablePossessions}</p>
                                                </div>
                                            </div>
                                            <hr />
                                        </>
                                    }

                                    {sasria !== "0.00" &&
                                        <>
                                            <div className="row py-2">
                                                <div id="DivPremiumBreakdownCar" className="col">
                                                    <Image src={this.props.profile.countryId === 244 ? '/Images/PremiumBreakdown/icon-sasria.svg' : '/Images/PremiumBreakdown/icon-nasria.svg'} alt='' />
                                                    <div>
                                                        <p>{this.props.profile.countryId === 244 ? 'Sasria' : 'Nasria'}</p>
                                                    </div>
                                                </div>
                                                <div className="col">
                                                    <p className="greenPremium">{this.props.profile.currencySymbol}{sasria}</p>
                                                </div>
                                            </div>
                                            <hr />
                                        </>
                                    }

                                    {discount !== "0.00" &&
                                        <>
                                            <div className="row py-2">
                                                <div id="DivPremiumBreakdownCar" className="col">
                                                    <Image src='/Images/PremiumBreakdown/icon-multicar-discount.svg' alt='' />
                                                    <div>
                                                        <p>Multiple car discount</p>
                                                    </div>
                                                </div>
                                                <div className="col">
                                                    <p className="greenPremium">{this.props.profile.currencySymbol}{discount}</p>
                                                </div>
                                            </div>
                                            <hr />
                                        </>
                                    }

                                    {emergency !== "0.00" &&
                                        <>
                                            <div className="row py-2">
                                                <div id="DivPremiumBreakdownCar" className="col">
                                                    <Image src='/Images/PremiumBreakdown/icon-king-s-emergency-assist.svg' alt='' />
                                                    <div>
                                                        <p>The king’s emergency assist</p>
                                                    </div>
                                                </div>
                                                <div className="col">
                                                    <p className="greenPremium">{this.props.profile.currencySymbol}{emergency}</p>
                                                </div>
                                            </div>
                                            <hr />
                                        </>
                                    }

                                    {warranty !== "0.00" &&
                                        <>
                                            <div className="row py-2">
                                                <div id="DivPremiumBreakdownCar" className="col">
                                                    <Image src='/Images/PremiumBreakdown/icon-warranty-insurance.svg' alt='' />
                                                    <div>
                                                        <p>Car warranty</p>
                                                    </div>
                                                </div>
                                                <div className="col">
                                                    <p className="greenPremium">{this.props.profile.currencySymbol}{warranty}</p>
                                                </div>
                                            </div>
                                            <hr />
                                        </>
                                    }

                                    {fees !== "0.00" &&
                                        <>
                                            <div className="row py-2">
                                                <div id="DivPremiumBreakdownCar" className="col">
                                                    <Image src='/Images/PremiumBreakdown/icon-broker-services.svg' alt='' />
                                                    <div>
                                                        <p className="">Broker advice fee</p>
                                                    </div>
                                                </div>
                                                <div className="col">
                                                    <p className="greenPremium">{this.props.profile.currencySymbol}{fees}</p>
                                                </div>
                                            </div>
                                            <hr />
                                        </>
                                    }

                                    {blingLikeNew !== "0.00" &&
                                        <>
                                            <div className="row py-2">
                                                <div id="DivPremiumBreakdownCar" className="col">
                                                    <Image src='/Images/PremiumBreakdown/icon-bling-like-new.svg' alt='' className="mr-4 mr-lg-3" />
                                                    <div>
                                                        <p>Like-new cellphone</p>
                                                    </div>
                                                </div>
                                                <div className="col">
                                                    <p className="greenPremium">{this.props.profile.currencySymbol}{blingLikeNew}</p>
                                                </div>
                                            </div>
                                            <hr />
                                        </>
                                    }

                                    {blingScreenFix !== "0.00" &&
                                        <>
                                            <div className="row py-2">
                                                <div id="DivPremiumBreakdownCar" className="col">
                                                    <Image src='/Images/PremiumBreakdown/icon-bling-screen-fix.svg' alt='' className="mr-4 mr-lg-3" />
                                                    <div>
                                                    <p>Screen-fix cellphone</p>
                                                    </div>
                                                </div>
                                                <div className="col">
                                                    <p className="greenPremium">{this.props.profile.currencySymbol}{blingScreenFix}</p>
                                                </div>
                                            </div>
                                            <hr />
                                        </>
                                    }

                                    {namfisa !== "0.00" &&
                                        <>
                                            <div className="row py-2">
                                                <div id="DivPremiumBreakdownCar" className="col">
                                                    <Image src='/Images/PremiumBreakdown/icon-nasria.svg' alt='' className="mr-4 mr-lg-3" />
                                                    <div>
                                                        <p>Monthly NAMFISA levy</p>
                                                    </div>
                                                </div>
                                                <div className="col">
                                                    <p className="greenPremium">{this.props.profile.currencySymbol}{namfisa}</p>
                                                </div>
                                            </div>
                                            <hr />
                                        </>
                                    }

                                    {stampDuty !== "0.00" &&
                                        <>
                                            <div className="row py-2">
                                                <div id="DivPremiumBreakdownCar" className="col">
                                                    <Image src='/Images/PremiumBreakdown/icon-nasria.svg' alt='' className="mr-4 mr-lg-3" />
                                                    <div>
                                                        <p>Monthly stamp duty</p>
                                                    </div>
                                                </div>
                                                <div className="col">
                                                    <p className="greenPremium">{this.props.profile.currencySymbol}{stampDuty}</p>
                                                </div>
                                            </div>
                                            <hr />
                                        </>
                                    }
                                </Card.Body>
                            </Card>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state: any) => {
    return {
        profile: state.profile,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        dispatchHideProfile: () => dispatch(hideMobileProfile()),
        dispatchRedirectTo: (destination) => dispatch(navigateTo(destination)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(PremuimBreakdown);